<script>
  import {SCORES}        from '../../../../constants/scores';
  import HelpButton      from '../../../help-button/help-button.svelte';
  import StatFilterScore from './stat-filter-score/stat-filter-score.svelte';

  export let stat;

  const statName = stat.name.replace(', Ground', ' (Ground)');
</script>

<style>
</style>

<template lang="pug" src="./stat-filter.pug"></template>
